module.exports = __webpack_public_path__ + "static/img/chart-pic10.64713187.png";